import React from 'react';
import { Flex, Card as MantineCard } from '@mantine/core';
import { t } from 'i18next';
import {
  Avatar,
  Button,
  Colors,
  SizesAvatar,
  TypesButton,
  Text,
  Typography,
  SizesButton,
} from 'goalsetter-webapp-components';
import { cardStyle, avatarContainerStyle, buttonStyle } from './styles';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';

interface UserItemProps {
  profileImageUrl?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  userName?: string | undefined;
  color?: string;
  onInvite?: () => void;
}

export const UserItem: React.FC<UserItemProps> = ({
  profileImageUrl,
  firstName,
  lastName,
  userName = '',
  color,
  onInvite,
}) => {
  const { isMobile } = useMediaQueryGs();

  return (
    <MantineCard
      shadow="sm"
      radius="lg"
      style={cardStyle(color, isMobile)}
    >
      <Flex
        align="center"
        style={avatarContainerStyle}
      >
        <Avatar
          user={profileImageUrl ? { profileImageUrl } : { firstName, lastName }}
          size={SizesAvatar.SMALL}
        />
        <Flex direction="column">
          <Text
            type={Typography.GSSUBTITLE2}
            color={Colors.BLACK}
          >
            {String(firstName)}
          </Text>
          <Text
            type={Typography.GSBODY3}
            color={Colors.BLACK}
          >
            {userName}
          </Text>
        </Flex>
      </Flex>
      <Button
        type={TypesButton.PRIMARY}
        size={SizesButton.EXTRA_SMALL}
        onClick={onInvite ? onInvite : () => null}
        style={buttonStyle}
      >
        {t('continue')}
      </Button>
    </MantineCard>
  );
};
